import React from "react";

export type AssetDimensionValues = {
    height: number | "";
    width: number | "";
    depth: number | "";
    dimensionUnit: string;

    weight: number | "";
    weightUnit: string;
};

interface AssetDimensionsProps {
    title: string;
    values: AssetDimensionValues;
    onChange: (
        field: keyof AssetDimensionValues,
        value: string | number
    ) => void;

    onRemove?: () => void;
}

// Options
const dimensionUnits = ["cm", "m", "in"];
const weightUnits = ["g", "kg", "lbs"];

// Field configs
const dimensionFields: { key: keyof AssetDimensionValues; label: string; type: "number" | "select"; options?: string[] }[] = [
    { key: "height", label: "H", type: "number" },
    { key: "width", label: "W", type: "number" },
    { key: "depth", label: "D", type: "number" },
    { key: "dimensionUnit", label: "Unit", type: "select", options: dimensionUnits },
];

const weightFields: { key: keyof AssetDimensionValues; label: string; type: "number" | "select"; options?: string[] }[] = [
    { key: "weight", label: "Weight", type: "number" },
    { key: "weightUnit", label: "Unit", type: "select", options: weightUnits },
];

const AssetDimensions: React.FC<AssetDimensionsProps> = ({
    title,
    values,
    onChange,
    onRemove
}) => {
    const handleNumberChange = (field: keyof AssetDimensionValues) =>
        (e: React.ChangeEvent<HTMLInputElement>) => {
            const value = e.target.value;
            onChange(field, value === "" ? "" : Number(value));
        };

    const handleStringChange = (field: keyof AssetDimensionValues) =>
        (e: React.ChangeEvent<HTMLSelectElement>) => {
            onChange(field, e.target.value);
        };

    return (
        <div className="measurement-card">

            <div className="measurement-header">
                <span className="measurement-title">
                    {title}
                </span>

                {onRemove && (
                    <button
                        type="button"
                        className="measurement-remove"
                        onClick={onRemove}
                    >
                        Remove
                    </button>
                )}
            </div>

            <div className="measurement-content">

                <div className="measurement-row">
                    {dimensionFields.map((f) => (
                        <div className="dim-field" key={f.key}>
                            <label>{f.label}</label>

                            {f.type === "number" ? (
                                <input
                                    type="number"
                                    value={values[f.key] as number | ""}
                                    onChange={handleNumberChange(f.key)}
                                    className="dim-input"
                                    min="0"
                                />
                            ) : (
                                <select
                                    value={values[f.key] as string}
                                    onChange={handleStringChange(f.key)}
                                    className="unit-input"
                                >
                                    {f.options?.map(opt => (
                                        <option key={opt} value={opt}>
                                            {opt}
                                        </option>
                                    ))}
                                </select>
                            )}
                        </div>
                    ))}
                </div>

                <div className="measurement-row">
                    {weightFields.map((f) => (
                        <div className="dim-field" key={f.key}>
                            <label>{f.label}</label>

                            {f.type === "number" ? (
                                <input
                                    type="number"
                                    value={values[f.key] as number | ""}
                                    onChange={handleNumberChange(f.key)}
                                    className="dim-input"
                                    min="0"
                                />
                            ) : (
                                <select
                                    value={values[f.key] as string}
                                    onChange={handleStringChange(f.key)}
                                    className="unit-input"
                                >
                                    {f.options?.map(opt => (
                                        <option key={opt} value={opt}>
                                            {opt}
                                        </option>
                                    ))}
                                </select>
                            )}
                        </div>
                    ))}
                </div>

            </div>
        </div>
    );
};

export default AssetDimensions;
